<template>
  <div id="default-layout-structure-page" class="page" refs="default-layout-structure">
    <el-row class="hp-row content-default" type="flex">
      <el-col class="left">

        <div class="sign-in-card gradient-card default">
          <div class="header">
            <h4 class="title">
              <!--- Sample title Here -->
            </h4>
          </div>
          <div class="body">
            body
          </div>
        </div>
      </el-col>

      <el-col class="right">
        Right Content
      </el-col>
    </el-row>
  </div>
</template>

<script src="./default-layout-structure.js"></script>
<style lang="scss" src="./default-layout-structure.scss"></style>
